<div *ngIf="config">
  <h3 *ngIf="!rulesets || rulesets.length === 0">No Rules Specified</h3>

  <div class="table-buttons">
    <div class="right">
      <button mat-icon-button *ngIf="!editingJson" (click)="toggleJsonEditor()" [disabled]="!canEditJson">
        <fa-icon icon="code"></fa-icon>
      </button>
      <button mat-icon-button *ngIf="editingJson" (click)="toggleJsonEditor()" [disabled]="!canEditJson">
        <fa-icon icon="table"></fa-icon>
      </button>
    </div>
    <mat-slide-toggle class="analyse-skipped-slider" [checked]="isSkipped" (change)="toggleSkipped()"
                      [disabled]="!canChangeSkippedStatus">Skipped
    </mat-slide-toggle>
  </div>

  <ng-container *ngFor="let ruleset of rulesets">
    <ng-container>

      <!-- Table View -->
      <ng-container *ngIf="!editingJson && ruleset.visible">
        <h3>{{ruleset.name}}</h3>
        <button mat-raised-button color="primary" (click)="addNewRule(ruleset)"
                [disabled]="!canAddRules">Add Rule
        </button>
        <ng-container *ngFor="let result of ruleset.rules">
          <table class="rule-results">
            <thead>
            <tr class="analysis-rule-name">
              <th [colSpan]="result.fields.length + 1" align="left">{{result.name}}</th>
            </tr>
            <tr class="analysis-rule-path">
              <th *ngFor="let field of result.fields"
                  align="left">{{field}}</th>
              <th align="right">code</th>
              <th align="right">test</th>
              <th align="right">description</th>
              <th>
                <button mat-raised-button color="primary" (click)="addToList(result, ruleset)"
                        [disabled]="!canAddRules">Add
                </button>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor=" let row of result.rules">
              <td *ngFor="let cell of row.expected">{{cell}}</td>
              <td>{{result.mnemonic}}-{{row.mnemonic}}</td>
              <td>{{row.test || ''}}</td>
              <td>{{row.description || ''}}</td>
              <td>
                <button mat-raised-button color="warn" (click)="editListEntry(row, result, ruleset)"
                        [disabled]="!canEditRules">
                  Edit
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </ng-container>
      </ng-container>

<!--      &lt;!&ndash;  or JSON View &ndash;&gt;-->
<!--      <ng-container *ngIf="editingJson">-->
<!--        <h3>{{ruleset.name}}</h3>-->
<!--        <div class="ace">-->
<!--          <ace (valueChange)="ruleset.setJson($event)"-->
<!--               [config]="aceEditableJsonConfig"-->
<!--               [value]="ruleset.json">-->
<!--          </ace>-->
<!--        </div>-->
<!--      </ng-container>-->

    </ng-container>
  </ng-container>

</div>
